<div class="pageheader">
    <div class="page-title">
        <h1>Tracking fields</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Tracking fields log'">
                <app-change-log-link-entity type="TrackingFieldType"></app-change-log-link-entity>
                <app-change-log-link-entity type="DisplayDataField"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<div class="container container-fixed">
    <div class="row">
        <div class="col-sm-12">

            <dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='fields' [bizSetGroupPanel]="false"
                [bizSetColumnChooser]="true" [bizSetAllowColumnReordering]="false" [bizSetPager]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)" (onRowRemoving)="onRowRemoving($event)">

                <dxo-editing mode="popup" [allowAdding]="allowAdding" [allowDeleting]="allowDeleting"></dxo-editing>

                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

                <dxo-group-panel [visible]="false"></dxo-group-panel>

                <dxi-column dataField="Name" caption="Key Name" dataType="string" width="20%" sortOrder="asc"
                    [allowFiltering]="false">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-column>

                <dxi-column dataField="DistributionObjectsId" caption="Document Type" width="20%">
                    <dxo-lookup [dataSource]="distros" valueExpr="Id" displayExpr="Name">
                    </dxo-lookup>
                    <dxo-header-filter [dataSource]="bizGridFiltervalues.getDocumentTypeFilterData(bizGridFiltervalues.getPropertyValues(this.fields, 'DistributionObjectsId'), distros)"/>  
                </dxi-column>

                <dxi-column
                    caption="Type"
                    dataType="string"
                    width="15%"
                    [allowFiltering]="false"
                    [calculateCellValue]="calculateType">
                </dxi-column>

                <dxi-column
                    caption="Value"
                    dataType="string"
                    width="50%"
                    [allowFiltering]="false"
                    [calculateCellValue]="calculateValue">
                </dxi-column>

                <dxi-column dataField="ShowInSearchPreview" caption="Search preview" dataType="boolean" width="10%"
                    [allowFiltering]="false">
                </dxi-column>

                <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.fields, 'CreatedBy'))"></dxo-header-filter></dxi-column>
                <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
                <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="true"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.fields, 'UpdatedBy'))"></dxo-header-filter>   </dxi-column>
                <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

                <dxi-column type="buttons">
                    <dxi-button name="edit"
                                template="editTemplate"
                                [visible]="allowEditing">
                    </dxi-button>
                    <dxi-button name="delete"></dxi-button>
                    <dxi-button text="Show Log"
                                template="logTemplate"
                                [visible]="allowShowLog">
                    </dxi-button>
                </dxi-column>
            
                <ng-container *dxTemplate="let cell of 'logTemplate'">
                    <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
                        <app-change-log-link-entity type="TrackingFieldType" [id]="cell.data.TrackingFieldTypesId"></app-change-log-link-entity>
                        <app-change-log-link-entity type="DisplayDataField" [id]="cell.data.DataField.DataFieldsId"></app-change-log-link-entity>
                    </app-change-log-link>
                </ng-container>

                <ng-container *dxTemplate="let cellInfo of 'editTemplate'">
                    <a class="dx-link" (click)="editTrackingField(cellInfo)"
                        *bizPermissionRequired="'Developer_Action_TrackingField_Edit'">Edit</a>
                    <span>&nbsp;</span>
                </ng-container>

            </dx-data-grid>

        </div>
    </div>
</div>
